"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
/**
 * 排序类型
 */
var ContentType;
(function (ContentType) {
    ContentType[ContentType["PAGE"] = 0] = "PAGE";
    ContentType[ContentType["BLOCK"] = 1] = "BLOCK";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
